var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid text-center"},[_c('h2',[_vm._v(_vm._s(_vm.$t("messages.error.forbidden")))]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" "+_vm._s(_vm.$t("links.home"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }